import React from "react"
import styled from "styled-components"
import remarkGfm from "remark-gfm"
import rehypeRaw from "rehype-raw"
import ReactMarkdown from "react-markdown"
function Announcements({ data }) {
  return (
    <Wrapper>
      <ReactMarkdown
        children={data.announcements}
        rehypePlugins={[rehypeRaw]}
        remarkPlugins={[remarkGfm]}
      />
    </Wrapper>
  )
}

export default Announcements

const Wrapper = styled.div`
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
  min-height: 400px;
  ol, ul {
    margin: 0;
    padding-left: 20px !important;
  }
  .announcements_h1 {
    font-size: 25px;
    @media (max-width: 767px) {
      font-size: 1.5rem;
    }
  }
  h1,
  h2,
  h3,
  h4,
  h5 {
    margin: 1rem 0;
  }
  @media (max-width: 479px) {
    /* margin-top: 20px; */
    h1 {
      font-size: 1.2rem;
      font-weight: 600;
    }
    h2 {
      font-size: 1.125rem;
      font-weight: 500;
    }
    h3 {
      font-size: 1rem;
      font-weight: 500;
    }
    li,
    p {
      font-size: 0.9rem;
    }
  }
  @media (max-width: 991px) {
    grid-area: 5/3/6/10;
  }
  @media (max-width: 767px) {
    grid-area: 5/2/6/11;
  }
  h1 {
    font-weight: 600;
    font-size: 24px;
    letter-spacing: 0.07em;
    color: var(--secondaryColor);
  }
  h2 {
    font-weight: 500;
    font-size: 22px;
    letter-spacing: 0.07em;
    color: var(--secondaryColor);
  }
  h3 {
    font-weight: 500;
    font-size: 20px;
    letter-spacing: 0.07em;
    color: var(--secondaryColor);
  }
  h4 {
    font-weight: 500;
    font-size: 18px;
    letter-spacing: 0.07em;
    color: var(--secondaryColor);
  }
  h5 {
    font-weight: 500;
    font-size: 16px;
    letter-spacing: 0.07em;
    color: var(--secondaryColor);
  }
  li {
    margin: 0.75rem 0;
    letter-spacing: 0.07em;
  }
  blockquote {
    border-left: 6px solid var(--purpleColor);
    margin: 0;
    padding-left: 1rem;
  }
  a {
    font-weight: 700;
    font-size: 18px;
    letter-spacing: 0.07em;
    @media (max-width: 550px) {
      font-size: 17px;
    }
  }
  p {
    font-size: 17px;
    font-weight: 400;
    letter-spacing: 0.07em;
    margin: 1rem 0;
    @media (max-width: 550px) {
      font-size: 0.9rem;
    }
    @media (max-width: 479px) {
      margin: 0.9rem 0;
    }
  }
  img {
    width: 45%;
    border-radius: 6px;
    @media (max-width: 479px) {
      width: 100%;
      margin: 0;
    }
  }
`
